import { render, staticRenderFns } from "./Wxpay.vue?vue&type=template&id=1db9fecd&scoped=true"
import script from "./Wxpay.vue?vue&type=script&lang=js"
export * from "./Wxpay.vue?vue&type=script&lang=js"
import style0 from "./Wxpay.vue?vue&type=style&index=0&id=1db9fecd&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db9fecd",
  null
  
)

export default component.exports